<template>
  <div class="part-container">
    <el-card class="v-block" :header="header">
      <template v-if="show">
        <m-table
          v-if="has('table')"
          v-bind="tableCfg"
          :i18n-path="i18nPath"
          :table-data="tableCfg.tableData || tableData"
          :hasPagination="false"
        ></m-table>
        <template v-if="has('tables')">
          <m-table
            v-for="cfg in tableCfg.tables"
            v-bind="cfg"
            :key="cfg.type"
            :i18n-path="i18nPath"
            :span-method="tableCfg.opt.spanMethod"
            :cell-class-name="tableCfg.opt.cellClassName"
            :hasPagination="false"
          ></m-table>
        </template>
        <div class="description" v-if="has('description') && description">
          <el-card>
            <div slot="header">{{ '说明' | translateTo(i18nPath) }}</div>
            <div>
              <p>{{ description }}</p>
            </div>
          </el-card>
        </div>
        <div class="chart-wrap" v-if="has('chart')">
          <div class="chart-box" v-for="(e, i) in charts" :key="i">
            <v-chart
              :options="e"
              :name="`${sn}-${names[i]}`"
              :autoresize="true"
              :theme="theme"
            ></v-chart>
          </div>
        </div>
        <div v-if="has('tips')" class="tips">{{ tips }}</div>
      </template>
      <div class="hint" v-else>
        <slot name="hint">{{ '暂无数据' | translateTo(i18nPath) }}</slot>
      </div>
    </el-card>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table';
import {
  mergeLineOpt,
  mergeBoxplot,
  makeSeries,
  theme,
  mergeBarOpt
} from '../utils/chart-option.js';

export default {
  name: 'part',
  components: {
    MTable
  },
  props: {
    i18nPath: String,
    header: String,
    sn: String,
    one: Boolean,
    show: {
      type: Boolean,
      default: true
    },
    names: {
      type: Array,
      default: () => []
    },
    chartOpts: {
      validator(v) {
        return typeof v === 'object';
      },
      default: null
    },
    type: {
      validator(v) {
        return ['line', 'bar', 'boxplot'].includes(v);
      }
    },
    tableData: {
      type: Array,
      default: () => []
    },
    option: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    tableCfg: {
      type: Object,
      default: () => ({})
    },
    xAxisType: {
      type: String,
      default: 'time'
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    charts() {
      return this[this.type]();
    }
  },
  data() {
    return {
      mergeLineOpt,
      theme
    };
  },
  methods: {
    has(key) {
      return this.option.split(',').includes(key);
    },
    line() {
      if (this.one) {
        return [
          mergeLineOpt({ series: this.chartOpts.map(makeSeries), xAxis: { type: this.xAxisType } })
        ];
      }
      return (this.chartOpts || []).map(e =>
        mergeLineOpt({ series: [makeSeries(e)], xAxis: { type: this.xAxisType } })
      );
    },
    bar() {
      return [mergeBarOpt(this.chartOpts || {})];
    },
    boxplot() {
      return [mergeBoxplot(this.chartOpts || {})];
    }
  }
};
</script>

<style lang="scss">
.part-container {
  margin-top: 10px;
  .chart-wrap {
    .chart-box {
      margin-top: 14px;
      height: 450px;
    }
  }
  .tips {
    white-space: pre-line;
    min-height: 50px;
    border: 1px solid;
    padding: 4px;
  }

  .description {
    white-space: pre-line;
  }
}
</style>
